const PREFIX = '/4337/bc.group1';
const APP_SEGMENT = 'bc.con';
const WEB_SEGMENT = 'bc.web';

import { AdPlacement } from '@/features/ads/shared/types/ad-placement';

export const adAddUnitPathPrefix = (placement: AdPlacement, isGamesApp: boolean): AdPlacement => {
  const segment = isGamesApp ? APP_SEGMENT : WEB_SEGMENT;
  const newPath = `${PREFIX}/${segment}/${placement.adUnitPath}`;
  const prebidAdUnit = placement.prebidAdUnit;
  return {
    ...placement,
    adUnitPath: newPath,
    prebidAdUnit: {
      ...prebidAdUnit,
      code: placement.code,
      ortb2Imp: {
        ...prebidAdUnit.ortb2Imp,
        ext: {
          ...prebidAdUnit.ortb2Imp,
          gpid: newPath,
          data: {
            ...prebidAdUnit.ortb2Imp?.ext.data,
            pbadslot: newPath,
          },
        },
      },
    },
  };
};
